import { AppInfoDocument } from "owfsa-graphql";
import { useQuery } from "@urql/vue";
import { computed } from "vue";

export default function useApiAppInfo() {
  const apiAppInfoQuery = useQuery({
    query: AppInfoDocument,
    pause: false,
    requestPolicy: "cache-first",
  });

  const apiAppInfo = computed(() =>
    apiAppInfoQuery?.data?.value?.appInfo,
  );
  
  const loading = computed(
    () => apiAppInfoQuery.fetching?.value,
  );

  return {
    apiAppInfo,
    loading,
  };
}
